import { createContext } from 'react';
export default /*#__PURE__*/createContext({
  id: 0,
  dispatch: function dispatch() {},
  reportAction: function reportAction() {}
});